"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchUserCountryCodeByIp = exports.setUserCountryCodeByIpCooke = exports.getUserCountryCodeByIpFromCookie = exports.getOrFetchAndUpdateCountryCodeByIpCookie = exports.getOrFetchAndUpdateCountryCodeByIpCookieUseQueryKey = void 0;
var date_fns_1 = require("date-fns");
var Cookies = __importStar(require("js-cookie"));
var unfetch_1 = __importDefault(require("unfetch"));
exports.getOrFetchAndUpdateCountryCodeByIpCookieUseQueryKey = 'getOrFetchAndUpdateCountryCodeByIpCookie';
var cookieName = 'geolocationCountryCodeByIp';
/**
 * Convenience function that properly manages the geolocationCountryCodeByIp cookie
 */
var getOrFetchAndUpdateCountryCodeByIpCookie = function () { return __awaiter(void 0, void 0, void 0, function () {
    var countryCode, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                countryCode = (0, exports.getUserCountryCodeByIpFromCookie)();
                if (!!countryCode) return [3 /*break*/, 2];
                return [4 /*yield*/, (0, exports.fetchUserCountryCodeByIp)()];
            case 1:
                result = _a.sent();
                (0, exports.setUserCountryCodeByIpCooke)(result.countryCode);
                return [2 /*return*/, { countryCode: result.countryCode }];
            case 2: return [2 /*return*/, { countryCode: countryCode }];
        }
    });
}); };
exports.getOrFetchAndUpdateCountryCodeByIpCookie = getOrFetchAndUpdateCountryCodeByIpCookie;
/**
 * @returns The country code of the user if the cookie is present. e.g. "US" or "CA"
 */
var getUserCountryCodeByIpFromCookie = function () {
    var countryCode = Cookies.get(cookieName);
    return countryCode;
};
exports.getUserCountryCodeByIpFromCookie = getUserCountryCodeByIpFromCookie;
var setUserCountryCodeByIpCooke = function (countryCode) {
    var twelveHoursFromNow = (0, date_fns_1.addHours)(new Date(), 12);
    Cookies.set(cookieName, countryCode, { expires: twelveHoursFromNow, sameSite: 'strict', secure: true });
};
exports.setUserCountryCodeByIpCooke = setUserCountryCodeByIpCooke;
/**
 * https://www.geojs.io/docs/v1/endpoints/country/
 */
var fetchUserCountryCodeByIp = function () { return __awaiter(void 0, void 0, void 0, function () {
    var res, text, TEST_CA, result_1, countryCode, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, unfetch_1.default)('https://get.geojs.io/v1/ip/country')];
            case 1:
                res = _a.sent();
                if (!!res.ok) return [3 /*break*/, 3];
                return [4 /*yield*/, res.text()];
            case 2:
                text = _a.sent();
                throw new Error("Server error fetching user geolocation; status: ".concat(res.status, "; text: ").concat(text));
            case 3:
                TEST_CA = false;
                if (TEST_CA) {
                    result_1 = { countryCode: 'CA' };
                    return [2 /*return*/, result_1];
                }
                return [4 /*yield*/, res.text()];
            case 4:
                countryCode = (_a.sent()).trim();
                result = { countryCode: countryCode };
                return [2 /*return*/, result];
        }
    });
}); };
exports.fetchUserCountryCodeByIp = fetchUserCountryCodeByIp;
